module.exports = __webpack_public_path__ + "static/media/loading-big.c72aeed9.gif";